import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

const LOGO = "https://customer-assets-m6fa6gv7.emergentagent.net/job_0dbeb9ed-131c-4cd1-83ca-d7c4e02f284b/artifacts/rg17olpw_WhatsApp%20Image%202026-10-01%20at%2011.40.01.jpeg";

export default function AdminLogin() {
  const { user, login, ready } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  if (ready && user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Bem-vindo de volta!");
      nav("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Erro ao fazer login");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] grid lg:grid-cols-2">
      <div className="hidden lg:flex relative overflow-hidden items-center justify-center p-10 border-r border-white/10 bg-grid">
        <div className="relative z-10 text-center">
          <img src={LOGO} alt="ActiveMode" className="h-28 w-28 object-contain mx-auto" />
          <h1 className="font-display text-5xl text-white tracking-tighter mt-6">ACTIVEMODE</h1>
          <p className="overline-label mt-3">Painel Administrativo</p>
        </div>
      </div>
      <div className="flex items-center justify-center p-6 lg:p-10">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="admin-login-form">
          <div className="overline-label">Acesso restrito</div>
          <h2 className="font-display text-4xl text-white tracking-tighter mt-3">Entrar</h2>
          <p className="text-sm text-zinc-400 mt-2">Use suas credenciais de administrador.</p>
          <div className="mt-8 space-y-4">
            <div>
              <Label className="text-xs text-zinc-400 mb-2 block">E-mail</Label>
              <Input data-testid="login-email" value={email} onChange={(e) => setEmail(e.target.value)} type="email" required className="bg-[#0A0A0C] border-white/15 h-12 text-white" />
            </div>
            <div>
              <Label className="text-xs text-zinc-400 mb-2 block">Senha</Label>
              <Input data-testid="login-password" value={password} onChange={(e) => setPassword(e.target.value)} type="password" required className="bg-[#0A0A0C] border-white/15 h-12 text-white" />
            </div>
            <Button type="submit" disabled={loading} data-testid="login-submit" className="w-full h-12 bg-white text-black hover:bg-zinc-200 uppercase tracking-widest text-xs">
              {loading ? "Entrando..." : "Entrar"}
            </Button>
          </div>
          <a href="/" className="text-xs text-zinc-500 mt-6 inline-block hover-underline">← Voltar à loja</a>
        </form>
      </div>
    </div>
  );
}
